import React from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

// Assumed item => 0 means String name
// item => 1 means Id
import { withTranslation } from "react-i18next";

const getItemId = (item, keyOverride = null) => {
  if (!item) return null; // ADD THIS LINE
  if (keyOverride && item[keyOverride] !== undefined) return item[keyOverride];
  if (item.id !== undefined) return item.id;
  if (item.value !== undefined) return item.value;
  if (item.closing_right_user_id !== undefined)
    return item.closing_right_user_id;
  if (item.user_id !== undefined) return item.user_id;
  const keys = Object.keys(item);
  return keys.length > 1 && keys[1] === "id" ? item[keys[1]] : item[keys[0]];
};

const getItemLabel = (item, keyOverride = null) => {
  if (!item) return ""; // ADD THIS LINE
  if (keyOverride && item[keyOverride] !== undefined) return item[keyOverride];
  if (item.name !== undefined) return item.name;
  if (item.label !== undefined) return item.label;
  if (item.closing_right !== undefined) return item.closing_right;
  const keys = Object.keys(item);
  return keys.length > 1 && keys[1] !== "id" ? item[keys[1]] : item[keys[0]];
};

const CommonDropdown = ({
  title,
  optionList,
  onChangeHandle,
  isRequired = false,
  titleview = true,
  value,
  containerClass = "",
  labelClass = "",
  selectClass = "",
  wrapClass = "",
  controlClass = "",
  hasError = false,
  errorMessage = "",
  customTitle = <></>,
  customPlaceHolder = null,
  disabled = false,
  noMarginBtm = false,
  optionValueKey = null,
  optionLabelKey = null,
  searchable = false,
  customSelectStyles,
}) => {
  const { t } = useTranslation(["workpermit", "util"]);

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "38px",
      borderColor: hasError ? "#ea001e" : base.borderColor,
    }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <div
      className={` ${containerClass !== "" ? containerClass : "slds-form-element"} select-remove-icon  ${hasError ? "slds-has-error" : ""} ${noMarginBtm ? "mb-0" : "mb-2"} w-100`}
    >
      {titleview && (
        <label
          className={` ${labelClass !== "" ? labelClass : "slds-form-element__label"} `}
        >
          {" "}
          {title}
          {isRequired ? (
            <abbr class="slds-required" title="required">
              *{" "}
            </abbr>
          ) : null}
        </label>
      )}
      {customTitle}
      {/* {isRequired && <span className="inputErrorMsg ">&nbsp;*</span>} */}
      <div className={wrapClass + " " + "slds-form-element__control"}>
        <div className={controlClass + " " + "slds-select_container"}>
          {(() => {
            const safeOptionList = (optionList || []).filter(Boolean); // was: optionList || []
            return searchable ? (
              <Select
                classNamePrefix="clide-searchable-select"
                options={safeOptionList.map((item) => ({
                  value: getItemId(item),
                  label: getItemLabel(item),
                }))}
                value={
                  value == null || value === ""
                    ? null
                    : (() => {
                        const found = safeOptionList.find(
                          (item) => String(getItemId(item)) === String(value),
                        );
                        return found
                          ? {
                              value: getItemId(found),
                              label: getItemLabel(found),
                            }
                          : null;
                      })()
                }
                onChange={(selectedOption) =>
                  onChangeHandle(selectedOption ? selectedOption.value : "")
                }
                placeholder={`${t("select")} ${!customPlaceHolder ? title : customPlaceHolder}`}
                noOptionsMessage={() => `${t("no")} ${title} ${t("available")}`}
                isDisabled={disabled}
                isClearable
                menuPlacement="auto"
                menuPosition="absolute"
                //menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                styles={customSelectStyles ? customSelectStyles : selectStyles}
              />
            ) : (
              <select
                className={` ${labelClass !== "" ? selectClass : "slds-select"} `}
                onChange={(event) => onChangeHandle(event.target.value)}
                value={value == null ? "" : value}
                disabled={disabled}
              >
                {safeOptionList.length ? (
                  <>
                    <option value={""}>
                      {t("select")}{" "}
                      {!customPlaceHolder ? title : customPlaceHolder}
                    </option>
                    {safeOptionList.map((item, index) => (
                      <option
                        key={`project-option-${index}`}
                        value={getItemId(item)}
                      >
                        {getItemLabel(item)}
                      </option>
                    ))}
                  </>
                ) : (
                  <option value={""}>
                    {t("no")} {title} {t("available")}
                  </option>
                )}
              </select>
            );
          })()}
        </div>
      </div>
      {hasError ? (
        <div class="slds-form-element__help" id="error-01">
          {errorMessage !== "" ? errorMessage : t("mandatory")}
        </div>
      ) : null}
    </div>
  );
};

CommonDropdown.defaultProps = {
  title: "",
  optionList: [],
  isRequired: true,
  onChangeHandle: () => {},
  value: "",
  disabled: false,
  searchable: false,
};

export default withTranslation(["uauc", "util"])(CommonDropdown);
